import React from 'react';

import './therapist-single.less';
import './therapist-single-loading.less';

class TherapistSingleLoading extends React.Component {
  render() {
    return (
      <div className="therapist-single-loading">
        <div className="therapist-single-loading__top-banner placeholder-box" />
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 col-md-4 col-md-offset-0 col-lg-4 therapist-single-loading__column">
              <div className="therapist-single-loading__content-title placeholder-box" />
              <div className="therapist-single-loading__content-rating placeholder-box" />
              <div className="therapist-single-loading__content-booked placeholder-box" />
              <div className="therapist-single-loading__content-button placeholder-box" />
              <div className="therapist-single-loading__content-box placeholder-box" />
            </div>
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-1 col-lg-6 col-lg-offset-1 therapist-single-loading__column therapist-single-loading__column--right">
              <div className="therapist-single-loading__content-grid">
                <div className="therapist-single-loading__content-grid-item placeholder-box" />
                <div className="therapist-single-loading__content-grid-item placeholder-box" />
              </div>
              <div className="therapist-single-loading__content-grid">
                <div className="therapist-single-loading__content-grid-item placeholder-box" />
                <div className="therapist-single-loading__content-grid-item placeholder-box" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TherapistSingleLoading;



// WEBPACK FOOTER //
// ./spa/Pages/Therapists/TherapistSingleLoading.jsx